import lodash from "lodash";
import { ewent } from "../../../reactive";
import { util } from "../../../util/util";
export class MessageBuffer {
    constructor() {
        this.new_message = ewent();
        this._messages = [];
    }
    add(message) {
        let i = this._messages.length;
        while (i > 0) {
            const msg = this._messages[i - 1];
            if (MessageBuffer.Message.equals(message, msg))
                return null;
            if (msg.timestamp < message.timestamp)
                break;
            i--;
        }
        this._messages.splice(i, 0, message);
        this.new_message.trigger(message);
        return message;
    }
    get() {
        return this._messages;
    }
}
(function (MessageBuffer) {
    let Message;
    (function (Message) {
        var padInteger = util.padInteger;
        function toString(msg) {
            return `${new Date(msg.timestamp).toString()} [${padInteger(msg.local_timestamp.hours, 2)}:${padInteger(msg.local_timestamp.minutes, 2)}:${padInteger(msg.local_timestamp.seconds, 2)}] ${msg.text}`;
        }
        Message.toString = toString;
        function equals(a, b) {
            if (!a || !b)
                debugger;
            return a.local_timestamp.stamp == b.local_timestamp.stamp && a.text == b.text;
        }
        Message.equals = equals;
        function color(m) {
            return lodash.findLast(m.fragments, f => f.color != null)?.color;
        }
        Message.color = color;
    })(Message = MessageBuffer.Message || (MessageBuffer.Message = {}));
})(MessageBuffer || (MessageBuffer = {}));
